import * as Combos from './combos';

const Actions = {
  ...Combos,
};

export default Actions;
